// Add this to your existing flash-messages.js file
// This is a partial implementation assuming you have a similar structure

import React, { useState, useEffect } from "react";
import { Snackbar, Button, IconButton } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";

// Global state for notices
let notices = [];
let setNoticesState = null;

export const addNotice = (notice) => {
  const newNotice = {
    id: Date.now(),
    type: "success",
    ...notice,
  };
  notices = [...notices, newNotice];
  if (setNoticesState) setNoticesState(notices);
};

export const addError = (error) => {
  const newError = {
    id: Date.now(),
    type: "error",
    ...error,
  };
  notices = [...notices, newError];
  if (setNoticesState) setNoticesState(notices);
};

export const DisplayFlashMessages = () => {
  const [localNotices, setLocalNotices] = useState(notices);

  useEffect(() => {
    setNoticesState = setLocalNotices;
    return () => {
      setNoticesState = null;
    };
  }, []);

  const handleClose = (id) => {
    notices = notices.filter((notice) => notice.id !== id);
    setLocalNotices(notices);
  };

  return (
    <>
      {localNotices.map((notice) => (
        <Snackbar
          key={notice.id}
          open={true}
          autoHideDuration={6000}
          onClose={() => handleClose(notice.id)}
        >
          <Alert
            severity={notice.type}
            action={
              <>
                {notice.action && (
                  <Button
                    color="inherit"
                    size="small"
                    onClick={notice.action.onClick}
                  >
                    {notice.action.text}
                  </Button>
                )}
                <IconButton
                  size="small"
                  color="inherit"
                  onClick={() => handleClose(notice.id)}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </>
            }
          >
            {notice.text}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};
